import { useCustomerStore } from '@stores/me/customer'
import { useDisciplineStore } from '@stores/discipline'

import { DEFAULT_SCOPE_REQUIRES, SCOPE_SOURCES } from '@config/scope/sources'
import { getScopeHomePath, resolveScope } from '@utils/scope/resolve-scope'
import { resolveSourceId } from '@utils/scope/source-id'
import { sourceStartMode } from '@utils/scope/source-start-mode'
import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
  const customerStore = useCustomerStore()
  const disciplineStore = useDisciplineStore()

  const target = resolveScope(to, customerStore.customer)
  if (!target) return show404()

  const { changed } = disciplineStore.setScope(target)

  const homePath = getScopeHomePath(target)
  const needsSubjectHome = !disciplineStore.activeDiscipline
    && !to.meta.scope?.allowsMissingSubject
    && to.path !== homePath
  if (needsSubjectHome) return navigateTo(homePath, { replace: true })

  const disciplineId = disciplineStore.activeDiscipline?.id ?? null
  const requires = to.meta.scope?.requires ?? DEFAULT_SCOPE_REQUIRES
  const loads = to.meta.scope?.loads ?? []

  const startedSources = [...requires, ...loads]
  const isSamePage = to.path === from.path

  startedSources.forEach((source) => {
    const definition = SCOPE_SOURCES[source]
    const id = resolveSourceId(definition.param, to.params, disciplineId)
    if (id === null) return

    const mode = sourceStartMode(definition, definition.status(id), { changed, isSamePage })
    if (mode) definition.start(id, mode)
  })
})
